module.exports = "<h1>\r\n Training Programs\r\n</h1>\r\n<p>\r\n  Here is the link for Training Programs : <a href=\"https://www.stcloudstate.edu/precisiondrivingcenter/55-plus/classroom.aspx\" target=\"_blank\"><button type=\"button\" class=\"btn btn-primary\">Click Here!</button></a> \r\n     <!--Nothing to see here-->\r\n</p>\r\n<p>\r\n    The Training Programs page will open in a new tab. Simply close that tab to return here.\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/training-programs/training-programs.component.html
// module id = ./src/app/training-programs/training-programs.component.html
// module chunks = main